module.exports = __webpack_public_path__ + "static/media/VelocityChart.30295f39.svg";